import { RoleTypes, IModuleRoute, AppRouteNamesList } from 'models';
import { CONSTANTS } from 'utils';

const partnersRequiredRoles = [RoleTypes.PRIMARY_ADMIN, RoleTypes.ADMIN];

export enum PartnersPathList {
	partners = '/partners',
	new = '/new',
	details = '/details',
	edit = '/details/edit',
}

export const partnersRoutes: IModuleRoute = {
	path: `${CONSTANTS.moduleAdminPath}${PartnersPathList.partners}`,
	name: AppRouteNamesList.partners,
	requiredRoles: partnersRequiredRoles,
	nested: [
		{
			path: PartnersPathList.new,
			name: AppRouteNamesList.partnersNew,
			requiredRoles: partnersRequiredRoles,
		},
		{
			path: PartnersPathList.details,
			name: AppRouteNamesList.partnersDetails,
			requiredRoles: partnersRequiredRoles,
		},
		{
			path: PartnersPathList.edit,
			name: AppRouteNamesList.partnersEdit,
			requiredRoles: partnersRequiredRoles,
		},
	],
};
